// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentCard_root__I4TN8","contentCardImage":"ContentCard_contentCardImage__wRAgw","contentCardTitle":"ContentCard_contentCardTitle__3P5af"};